import { z } from "zod";

import { machineBaseSchema } from "../machine-base";
import { machineTypeSchema } from "../machine-type";

export const everestMachineSchema = machineBaseSchema.extend({
	machineType: z.literal(machineTypeSchema.enum.Everest),
	status: z.string().transform(() => "Disabled" as const),
});

export type EverestMachine = z.infer<typeof everestMachineSchema>;

export const prepareEverestMachineData = (data: unknown): unknown => {
	if (typeof data !== "object" || data === null) {
		return data;
	}

	const input = data as Record<string, unknown>;

	// Everest is a non-cloud reference machine hardcode the known default.
	const iotDevice = {
		hubName: input.iotHubName ?? "",
		deviceId: input.iotEdgeDeviceId ?? "",
		moduleId: input.iotEdgeModuleId ?? "",
		moduleVersion: input.edgeModuleVersion ?? "",
		lastProofOfLife: input.lastProofOfLifeTimeStamp,
	};

	const stopReason = { stopCode: -1, message: "Offline", arguments: [] as number[], isError: false };
	const activeWarnings: { message: string; code: number; arguments: number[] }[] = [];

	return {
		id: input.id ?? "",
		tenantId: input.tenantId ?? "",
		assetId: input.assetId ?? "",
		alias: input.alias ?? "",
		description: input.description ?? "",
		plcVersion: input.plcVersion ?? "",
		machineType: "Everest",
		status: "Disabled",
		productionStatus: input.productionStatus ?? "Unknown",
		stopReason,
		activeWarnings,
		workstations: [],
		iotDevice: input.iotEdgeDeviceId ? iotDevice : null,
		ipOrDnsName: input.ipOrDnsName ?? "",
		port: input.port ?? 80,
		securePrintConfiguration: { delayLabelRetrieval: false },
	};
};
